<ng-container *ngIf="searchStore.viewModel$ | async as viewModel">
  <app-x-search
    [value]="viewModel.searchString"
    (valueChange)="searchStore.onInputChange($event)"
    [placeholder]="placeholder"
    (focus)="searchStore.setInputFocused(true)"
    (blur)="searchStore.setInputFocused(false)"
    (forceSearch)="buttonSearchClick.emit()"
    [isActive]="viewModel.inputFocused || !!viewModel.searchString || isMobile"
    [withSearchButton]="withSearchButton"
  ></app-x-search>

  <div class="results" *ngIf="viewModel.inputFocused || !!viewModel.searchString || isMobile">
    <ng-container *ngIf="viewModel.searchString === ''">
      <app-x-search-list-title>{{ 'previous_searches' | translate}}</app-x-search-list-title>
      <app-x-search-list-item
        [breadcrumb]="'no_previous_searches' | translate"
        [iconName]="'menu-checkmark-mixed'"
      ></app-x-search-list-item>
      <app-x-divider
        [type]="'medium'"
        [orientation]="'horizontal'"
        [customColor]="'rgba(0, 0, 0, 0.10)'"
        style="width: 100%"
      ></app-x-divider>
    </ng-container>
    <div *ngIf="viewModel.isNibSearchActive" class="nib-parameters">
      <app-x-search-list-title>{{ 'nib_parameters' | translate }}</app-x-search-list-title>
      <div class="selects">
        <app-x-autocomplete
          [placeholder]="'Kabupaten'"
          [options]="viewModel.kabupatenList"
          [selectedId]="''"
          (selectedIdChange)="searchStore.onKabupatenSelect($event)"
          (searchStringChange)="searchStore.updateKabupatenList($event)"
        ></app-x-autocomplete>
        <app-x-autocomplete
          [placeholder]="'Desa'"
          [selectedId]="''"
          (selectedIdChange)="searchStore.onDesaSelect($event)"
          [disabled]="!viewModel.selectedKabupaten"
          (searchStringChange)="searchStore.requestDesaListByString($event)"
          [options]="viewModel.desaList"
        ></app-x-autocomplete>
        <app-x-autocomplete
          [placeholder]="'Usage'"
          [options]="searchTemp.ownershipList$ | async"
          [selectedId]="''"
          (selectedIdChange)="searchStore.onOwnershipSelect($event)"
        ></app-x-autocomplete>
      </div>
    </div>

    <ng-container
      *ngIf="
        viewModel.isPerareResultsLoading ||
        viewModel.isSearchStarted ||
        viewModel.isPerareResultsError
      "
    >
      <app-x-search-list-title>{{ 'results' | translate }}</app-x-search-list-title>

      <ng-container *ngIf="!viewModel.isPerareResultsLoading; else loading">
        <ng-container *ngIf="!viewModel.isPerareResultsError; else errorTemplate">
          <ng-container *ngIf="getPerareResultsForDisplay(viewModel.perareResults) as perareResultsToShow">
          <ng-container *ngIf="perareResultsToShow.length; else emptyTemplate">
            @for (result of perareResultsToShow; track result) {
              <app-x-search-list-item
                (click)="onPerareResultClick(result)"
                [iconName]="'map-2'"
                [type]="'single'"
                [singleText]="result.title"
                [breadcrumb]="result.description"
                [withHover]="true"
                [selected]="isPerareResultSelected(result)"
              ></app-x-search-list-item>
            }
          </ng-container>
          </ng-container>
        </ng-container>
      </ng-container>
    </ng-container>

    <ng-container
      *ngIf="
        !shouldHideMapboxResults(viewModel.perareResults) &&
        (
          viewModel.isMapboxResultsLoading ||
          viewModel.isSearchStarted ||
          viewModel.isMapboxResultsError
        )
      "
    >
      <app-x-divider
        [type]="'medium'"
        [orientation]="'horizontal'"
        [customColor]="'rgba(0, 0, 0, 0.10)'"
        style="width: 100%"
      ></app-x-divider>
      <app-x-search-list-title>{{ 'places' | translate }}</app-x-search-list-title>

      <ng-container *ngIf="!viewModel.isMapboxResultsLoading; else loading">
        <ng-container *ngIf="!viewModel.isMapboxResultsError; else errorTemplate">
          <ng-container *ngIf="(viewModel.mapboxResults ?? []).length; else emptyTemplate">
            @for (result of viewModel.mapboxResults ?? []; track result) {
              <app-x-search-list-item
                (click)="onMapboxResultClick(result)"
                [iconName]="'location'"
                [type]="'stacked'"
                [stackedTextTitle]="result.text ?? ''"
                [stackedTextSubtitle]="result.place_name ?? ''"
                [breadcrumb]="result.place_type?.[0] ?? ''"
                [withHover]="true"
                [selected]="isMapboxResultSelected(result)"
              ></app-x-search-list-item>
            }
          </ng-container>
        </ng-container>
      </ng-container>
    </ng-container>
  </div>

  <ng-template #loading>
    <div
      style="width: 100%; height: 48px; display: flex; justify-content: center; align-items: center"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        class="spinning-el"
      >
        <path
          d="M19.7525 9.17833L19.477 8.5134L19.1447 7.875L18.758 7.26799L18.3199 6.697L17.8336 6.16637L17.303 5.68013L16.732 5.242L16.125 4.85529L15.4866 4.52296L14.8217 4.24754L14.1353 4.03111L13.4326 3.87534L12.719 3.78139L12 3.75L11.281 3.78139L10.5674 3.87534L9.86474 4.03111L9.17833 4.24754L8.5134 4.52296L7.875 4.85529L7.26799 5.242L6.697 5.68013L6.16637 6.16637L5.68013 6.697L5.242 7.26799L4.85529 7.875L4.52296 8.5134L4.24754 9.17833L4.03111 9.86474L3.87534 10.5674L3.78139 11.281L3.75 12L3.78139 12.719L3.87534 13.4326L4.03111 14.1353L4.24754 14.8217L4.52296 15.4866L4.85529 16.125L5.242 16.732L5.68013 17.303L6.16637 17.8336L6.697 18.3199L7.26799 18.758L7.875 19.1447L8.5134 19.477L9.17833 19.7525L9.86474 19.9689L10.5674 20.1247L11.281 20.2186L12 20.25L12.719 20.2186L13.4326 20.1247L14.1353 19.9689L14.8217 19.7525L15.4866 19.477L16.125 19.1447L16.732 18.758L17.303 18.3199"
          stroke="#18A0FB"
          stroke-width="1.5"
          stroke-linecap="round"
        />
      </svg>
    </div>
  </ng-template>

  <ng-template #emptyTemplate>
    <app-x-search-list-item
      [breadcrumb]="'no_places_found' | translate"
      [iconName]="'menu-checkmark-mixed'"
    ></app-x-search-list-item>
  </ng-template>

  <ng-template #errorTemplate>
    <app-x-search-list-item
      [breadcrumb]="'Server error'"
      [iconName]="'menu-checkmark-mixed'"
    ></app-x-search-list-item>
  </ng-template>
</ng-container>
